import { createAsyncThunk } from '@reduxjs/toolkit';
import CustomerAPI from 'config/api/CustomerAPI';
import { notify } from 'helpers/NotifyHelper';
import { getDeviceId } from 'helpers/StorageHelper';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

// Get Compare List
export const getCompareListAPI = createAsyncThunk(
  'compare/fetch',
  async (_: void, { rejectWithValue }) => {
    const payload = { session_id: getDeviceId() };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.compareList.url,
        CustomerAPI.compareList.method,
        payload
      );
      if (res?.status === false) {
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Remove from Compare
export const removeFromCompareAPI = createAsyncThunk(
  'compare/remove',
  async (compareProductId: string, { rejectWithValue }) => {
    const payload = {
      product_id: compareProductId,
      session_id: getDeviceId(),
    };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.removeFromCompare.url,
        CustomerAPI.removeFromCompare.method,
        payload
      );
      if (res?.status === false) {
        // The server says "product_id is invalid" when the product is no longer in the compare list
        // (already removed - a double click, or removed from another tab). The list is exactly what
        // the customer asked for, so that is a successful removal: no error toast, and no rejection
        // (which would flip the item back to "compared" on screen).
        if (/product_id is invalid/i.test(String(res.message ?? ''))) {
          return { status: true, message: res.message, alreadyRemoved: true };
        }
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Add to Compare
export const addToCompareAPI = createAsyncThunk(
  'compare/add',
  async (productId: string, { rejectWithValue }) => {
    const payload = {
      product_id: productId,
      session_id: getDeviceId(),
    };
    try {
      const res: any = await manageAPICall(
        CustomerAPI.addToCompare.url,
        CustomerAPI.addToCompare.method,
        payload
      );
      if (res?.status === false) {
        notify.error(res.message);
        return rejectWithValue(res);
      }
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
